var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCustomerCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6EEED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.53 19.77C29.46 19.76 29.39 19.76 29.32 19.77C27.77 19.72 26.54 18.45 26.54 16.89C26.54 15.3 27.83 14 29.43 14C31.02 14 32.32 15.29 32.32 16.89C32.31 18.45 31.08 19.72 29.53 19.77Z",
    fill: "#8D5245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7901 26.6999C31.6701 27.4499 30.1001 27.7299 28.6501 27.5399C29.0301 26.7199 29.2301 25.8099 29.2401 24.8499C29.2401 23.8499 29.0201 22.8999 28.6001 22.0699C30.0801 21.8699 31.6501 22.1499 32.7801 22.8999C34.3601 23.9399 34.3601 25.6499 32.7901 26.6999Z",
    fill: "#8D5245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4399 19.77C18.5099 19.76 18.5799 19.76 18.6499 19.77C20.1999 19.72 21.4299 18.45 21.4299 16.89C21.4299 15.29 20.1399 14 18.5399 14C16.9499 14 15.6599 15.29 15.6599 16.89C15.6599 18.45 16.8899 19.72 18.4399 19.77Z",
    fill: "#8D5245"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5501 24.8501C18.5501 25.8201 18.7601 26.7401 19.1401 27.5701C17.7301 27.7201 16.2601 27.4201 15.1801 26.7101C13.6001 25.6601 13.6001 23.9501 15.1801 22.9001C16.2501 22.1801 17.7601 21.8901 19.1801 22.0501C18.7701 22.8901 18.5501 23.8401 18.5501 24.8501Z",
    fill: "#8D5245"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 27.87C24.04 27.86 23.95 27.86 23.86 27.87C22.02 27.81 20.55 26.3 20.55 24.44C20.56 22.54 22.09 21 24 21C25.9 21 27.44 22.54 27.44 24.44C27.43 26.3 25.97 27.81 24.12 27.87Z",
    fill: "#8D5245"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 29.9399C19.36 30.9499 19.36 32.6099 20.87 33.6099C22.59 34.7599 25.41 34.7599 27.13 33.6099C28.64 32.5999 28.64 30.9399 27.13 29.9399C25.42 28.7899 22.6 28.7899 20.87 29.9399Z",
    fill: "#8D5245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomerCardIcon);
export default __webpack_public_path__ + "static/media/dashboard-customer-card-icon.9d38c73b935db151aa3f536030dbf886.svg";
export { ForwardRef as ReactComponent };